import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import SectionTitle from "../section-title/SectionTitle";
import axios from "axios";



const AboutUs = () => {
  const [homeWeAre, setHomeWeAre] = useState(null);
  // console.log("why", homeWeAre);
  const fetchHomeWeare = async () => {
    try {
      const response = await axios.get(
        "https://rss.fastwebforge.com/api/pages/home"
      );
      setHomeWeAre(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchHomeWeare();
  }, []);

  //   console.log("Fetched Data:", homeWeAre);
  let heroSection = null;
  if (homeWeAre && homeWeAre.data && homeWeAre.data.sections) {
    heroSection = homeWeAre.data.sections.find(
      (section) => section.title === "home_about"
    );
  }


  return (
    <>
      {/* About Start */}
      <div className="about-sec pt-100 pb-100">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <div className="about-desc">
                {heroSection && heroSection.items
                  ? heroSection &&
                    heroSection.items.map(
                      (data, i) =>
                        data.title.includes("home_about_content") && (
                          <div key={i}>
                            <SectionTitle
                              title={data.contents.html}
                              content={data.contents.short_description}
                            />
                          </div>
                        )
                    )
                  : null}

                <div className="about-countup">
                  {heroSection && heroSection.items
                    ? heroSection &&
                      heroSection.items.map(
                        (data, i) =>
                          data.title.includes("home_content_item_") && (
                            <div key={i} className="counting-inner">
                              <div className="countup-text">
                                <h2 className="counter">
                                  <CountUp
                                    end={data.contents.title}
                                    duration={2.5}
                                    delay={0.9}
                                    start={0}
                                  />
                                </h2>
                                <h4>{data.contents.subtitle}</h4>
                              </div>
                            </div>
                          )
                      )
                    : null}
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="about-us-img">
                {heroSection && heroSection.items
                  ? heroSection &&
                    heroSection.items.map(
                      (data, i) =>
                        data.title.includes("home_about_content") && (
                          <div key={i}>
                            <img src={data.contents.image} alt="About Thumb" />
                          </div>
                        )
                    )
                  : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}
    </>
  );
};

export default AboutUs;
